module.exports = __webpack_public_path__ + "img/charger-speeds-desktop-fr.e6eeb91c.webp";